import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueLogger from 'vuejs-logger';
import VueKeyCloak from '@dsb-norge/vue-keycloak-js';
import i18n from './i18n'
import Vuex from 'vuex'
import  { BootstrapVue , IconsPlugin} from 'bootstrap-vue'
import store from './store';
import vSelect from "vue-select";
import VueApexCharts from 'vue-apexcharts'

Vue.use(Vuex)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueApexCharts)
Vue.component("v-select", vSelect);
Vue.component('apexchart', VueApexCharts)

Vue.config.productionTip = false


const options = {
  isEnabled: true,
  logLevel : 'debug',
  stringifyArguments : false,
  showLogLevel : true,
  showMethodName : false,
  separator: '|',
  showConsoleColors: true
};

Vue.use(VueLogger, options);

Vue.use(VueKeyCloak, {
  init: {
    // Use 'login-required' to always require authentication
    // If using 'login-required', there is no need for the router guards in router.js
    onLoad: 'login-required'
  },
  config: {
    url: process.env.VUE_APP_KEYCLOAK_BASE_URL,
    clientId: process.env.VUE_APP_KEYCLOAK_CLIENT_ID,
    realm: process.env.VUE_APP_KEYCLOAK_REALM,
  },
  onReady: (keycloak) => {
    store.dispatch('auth/setToken', keycloak.token).then(() => {
      Vue.$log.debug("Token set." + keycloak.token);
    });

    new Vue({ 
      router,
      store,
      i18n,
      render: h => h(App)      
    }).$mount('#app')
  },
  onTokenExpired: (keycloak) => {
    Vue.$log.debug('token expired', keycloak.token);
    keycloak.updateToken(30).then((refreshed) => {
      if (refreshed) {
        store.dispatch('auth/refreshToken', keycloak.token).then(() => {
          Vue.$log.debug('Token refreshed' + refreshed);
        });
      } else {
        Vue.$log.warn('Token not refreshed, valid for '
            + Math.round(keycloak.tokenParsed.exp + keycloak.timeSkew - new Date().getTime() / 1000) + ' seconds');
      }
    }).catch(() => {
      Vue.$log.error('Failed to refresh token');
      router.go();
    });
  }
})